import { Component, Input, OnInit } from '@angular/core';
import { MarianomGeneral } from '../../components/marianom-general.service';
import { CheckboxSubcategoria, CheckboxCategorias } from '../../components/etc/categoria-checkbox.interface';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { EcommerceGenericoService } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';

@Component({
  selector: 'mmax-ofertasview',
  templateUrl: './mmax-ofertasview.component.html',
  styleUrls: ['./mmax-ofertasview.component.scss']
})
export class MmaxofertasviewComponent implements OnInit {
  @Input('mode') modo: string = 'normal';
  @Input() ofertasDisplay: string = 'none';
  @Input() promosDisplay: string = 'none';

  constructor(private serv: MarianomGeneral, private genServ : EcommerceGenericoService,private router: ActivatedRoute) {
    this._destroyed$ = new Subject();
    this.numeropaginas = 0;
  
  }

  ngOnInit(): void {
    this.router.data.subscribe(data => {
      this.modo = data['mode'] || this.modo || 'normal';
    })

    let congas: CheckboxSubcategoria = {
      nombre: 'Con Gas',
      activada: false,
    }
    let singas: CheckboxSubcategoria = {
      nombre: 'Sin Gas',
      activada: false,
    }
    this.gaseosas = [
      {
        nombre: 'Tipo de productos',
        categorias: [congas, singas]
      }
    ]

  }

  private manejoDisplay(items: any[], displayProp: string): void {
    this[displayProp] = items.length !== 0 ? 'block' : 'none';
  }

  get ofertas() {
    const ofertas = this.genServ.getOfertas();
    this.manejoDisplay(ofertas, 'ofertasDisplay');
    //console.log("Esto es ofertas en elcomponente", ofertas);
    
    return ofertas;
  }

  get promos() {
    const promos = this.genServ.getPromocionesEcommerce();
    this.manejoDisplay(promos, 'promosDisplay');
    //console.log("Esto es promos en elcomponente", promos);

    return promos;
  }
  get ocultarPrecios (){
    return this.genServ.isOcultarPrecio()
  }
  gaseosas: CheckboxCategorias[];
  private _destroyed$: Subject<any>;
  numeropaginas: number;

}
